import React, { useEffect, useRef } from "react";
import { Container } from "@mui/material";
import { getToken } from "firebase/messaging";
import { saveTokenToFirestore, messaging } from "../firebase";
import { useAuthUser } from "../hooks/useAuthUser";
import AppHeader from "../components/AppHeader";
import IdeaEvaluation from "./ideaEvaluation";
import Comentarios from "./comentarios";

const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.error("Permiso de notificaciones denegado");
      return;
    }
    const token = await getToken(messaging, {
      vapidKey:
        "BCRyW5s55PL8nMiFlqO3AJgOkxCH-oDhzzSyfE5XoGgV2XXwFTWrAXtX3WiHLEluAU6H4Gs5jt0U1Sg5flOKV0Q",
    });
    if (token) {
      await saveTokenToFirestore(token);
    } else {
      console.error("No se pudo obtener el token FCM");
    }
  } catch (error) {
    console.error("Error al obtener el token FCM:", error);
  }
};

const Home = ({ handleLogout }) => {
  const { user, profile, isAuthenticated } = useAuthUser();
  const permissionRequested = useRef(false);

  useEffect(() => {
    if (isAuthenticated && !permissionRequested.current) {
      permissionRequested.current = true;
      requestNotificationPermission();
    }
  }, [isAuthenticated]);

  return (
    <Container disableGutters>
      <AppHeader
        variant="app"
        user={{ displayName: profile?.displayName || user?.displayName, profileImageUrl: profile?.profileImageUrl }}
        onLogout={handleLogout}
      />
      <Container sx={{ pt: 10, pb: 4 }}>
        <IdeaEvaluation />
        <Comentarios />
      </Container>
    </Container>
  );
};

export default Home;
